import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputOptionMaster,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  titleModal,
} from "App/utils/helpers";

export const RESET_STATE_MENU_ACCESS = {
  id: "",
  access_code: "",
  access_name: "",
  field_name: "",
  table_name: "",
  url: "",
  type_service: 1,

  label: "",
  value: "id",
};

export const TYPE_SERVICE_MASTER = 1;
export const TYPE_SERVICE_REGISTRASI = 2;
export const TYPE_SERVICE_BILLING = 3;
export const TYPE_SERVICE_WAREHOUSE = 4;

export const typeServiceSelect = [
  {
    value: TYPE_SERVICE_MASTER,
    label: "Master",
  },
  {
    value: TYPE_SERVICE_REGISTRASI,
    label: "Registrasi",
  },
  {
    value: TYPE_SERVICE_BILLING,
    label: "Billing",
  },
  {
    value: TYPE_SERVICE_WAREHOUSE,
    label: "Warehouse",
  },
];

export const typeServiceName = (type) => {
  if (parseInt(type) === TYPE_SERVICE_MASTER) {
    return "Master";
  } else if (parseInt(type) === TYPE_SERVICE_REGISTRASI) {
    return "Registrasi";
  } else if (parseInt(type) === TYPE_SERVICE_BILLING) {
    return "Billing";
  } else if (parseInt(type) === TYPE_SERVICE_WAREHOUSE) {
    return "Warehouse";
  } else {
    return "Tidak Terdefinisi";
  }
};

export const urlGet = "/access/access/listaccess";
export const urlAdd = "/access/access/addaccess";
export const urlUpdate = "/access/access/updateaccess";
export const urlDelete = "/access/access/deleteaccess";

export const deleteMenuAccessById = async (id) => {
  try {
    await instance2.post(
      urlDelete,
      {},
      {
        headers: {
          idaccess: id,
        },
      }
    );
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "access_code",
    disablePadding: false,
    label: "ACCESS CODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "access_name",
    disablePadding: false,
    label: "ACCESS NAME",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "field_name",
    disablePadding: false,
    label: "FIELD NAME",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "table_name",
    disablePadding: false,
    label: "TABLE NAME",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({
  setShowModal,
  formData,
  setFormData,
  setNewData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const add = async () => {
    return instance2.post(urlAdd, {
      ...formData,
    });
  };

  const update = () => {
    return instance2.post(
      urlUpdate,
      {
        ...formData,
      },
      {
        headers: {
          idaccess: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await add();
          defaultToastSuccess("Berhasil menambah data");
        } else if (formData.id !== "") {
          await update();
          defaultToastSuccess("Berhasil mengubah data");
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_MENU_ACCESS);
        setShowModal(false);
        setNewData();
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal title={`${titleModal(formData.id)} Access`} show={setShowModal}>
      <form action='' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='access_code'
              label='ACCESS CODE'
              id='access_code'
              value={formData.access_code}
              onChange={handleChange("access_code")}
              placeholder='Access Code'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='access_name'
              label='ACCESS NAME'
              id='access_name'
              value={formData.access_name}
              onChange={handleChange("access_name")}
              placeholder='Access Name'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='field_name'
              label='FIELD NAME'
              id='field_name'
              value={formData.field_name}
              onChange={handleChange("field_name")}
              placeholder='Field Name'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='table_name'
              label='TABLE NAME'
              id='table_name'
              value={formData.table_name}
              onChange={handleChange("table_name")}
              placeholder='Table Name'
            />
          </Grid>

          <Grid item sm={12}>
            <InputOptionMaster
              name='type_service'
              label='TYPE SERVICE'
              id='type_service'
              withSearch={false}
              value={formData.type_service}
              onChange={handleChange("type_service")}
              data={typeServiceSelect}
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='url'
              label='URL'
              id='url'
              value={formData.url}
              onChange={handleChange("url")}
              placeholder='Url'
            />
          </Grid>

          <Grid item sm={6}>
            <InputTextMaster
              name='label'
              label='LABEL'
              id='label'
              value={formData.label}
              onChange={handleChange("label")}
              placeholder='Label'
            />
          </Grid>

          <Grid item sm={6}>
            <InputTextMaster
              name='value'
              label='VALUE'
              id='value'
              value={formData.value}
              onChange={handleChange("value")}
              placeholder='Value'
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
